import { stringifyUrl } from 'query-string'
import { ReactElement } from 'react'

import { Button } from '@syconium/little-miss-figgy'

import { NextLink } from '../../../../../app/_components/navigation/NextLink'
import { useCartDialog } from '../../../../../app/_providers/CartProvider.client'
import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { CartContainer } from '../../../../../brunswick/containers/cart'
import { useMakeCartItem } from '../../../../../brunswick/containers/cart/utils'

import { Recommendation } from './BundleUpsells'
import {
  Details,
  DetailsText,
  ProductName,
  SizeAndColorText,
  UpsellTile as StyledTile,
  Thumbnail,
  TileContentsWrapper,
} from './styles'

export const BundleUpsellTile = ({
  recommendation,
}: {
  recommendation: Recommendation
}): ReactElement => {
  const makeCartItem = useMakeCartItem()
  const { addItems } = CartContainer.useContainer()
  const { close: closeCartDialog } = useCartDialog()
  const { cart: miniCartCopy } = useTranslation()

  const productHref = stringifyUrl({
    url: recommendation.urlPath!,
    query: { color: recommendation.colorId, size: recommendation.sizeId },
  })

  const canAddToCart =
    !!recommendation.availableForSale &&
    !!recommendation.price &&
    !!recommendation.shopifyVariantId &&
    !!recommendation.shopifyProductId &&
    !!recommendation.productHandle

  return (
    <StyledTile>
      <TileContentsWrapper>
        {recommendation.imageUrl ? (
          <NextLink
            href={productHref}
            $display='block'
            onClick={() => {
              closeCartDialog()
            }}
          >
            <Thumbnail imgUrl={recommendation.imageUrl} />
          </NextLink>
        ) : null}
        <Details>
          <DetailsText>
            <ProductName>{recommendation.title}</ProductName>
            <SizeAndColorText>
              {recommendation.sizeDisplayValue}&nbsp;•&nbsp;{recommendation.colorDisplayValue}
            </SizeAndColorText>
          </DetailsText>

          <Button
            allCaps
            block
            variant='secondary'
            disabled={!canAddToCart}
            onClick={() => {
              addItems(
                makeCartItem({
                  product: { handle: recommendation.productHandle! },
                  variant: {
                    shopifyId: recommendation.shopifyVariantId!,
                    shopifyProductId: recommendation.shopifyProductId!,
                    sku: recommendation.sku,
                    price: recommendation.price!,
                    compareAtPrice: recommendation.compareAtPrice,
                  },
                  variantGroup: {
                    siteWidePromoEligible: recommendation.siteWidePromoEligible ?? false,
                    finalSale: recommendation.finalSale ?? false,
                    primaryCategory: { id: recommendation.primaryCategory?.id ?? '' },
                  },
                  options: { attributedPortal: undefined },
                })
              )
            }}
            size='small'
          >
            {miniCartCopy.add}
          </Button>
        </Details>
      </TileContentsWrapper>
    </StyledTile>
  )
}
